import LoginPage from '@/views/login/LoginPage.vue'
import ResetPasswordPage from '@/views/login/ResetPasswordPage.vue'
import ForgotPasswordPage from '@/views/login/ForgotPasswordPage.vue'
import ConfirmationAccountPage from '@/views/login/ConfirmationAccountPage.vue'
import RegisterPage from '@/views/login/RegisterPage.vue'
import GuestLayout from '@/layouts/GuestLayout.vue'

export default [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    },
    alias: '/login'
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordPage,
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordPage,
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    },
  },
  {
    path: '/confirmation-account',
    name: 'ConfirmationAccount',
    component: ConfirmationAccountPage,
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage,
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    },
  }
]
